export default __webpack_public_path__ + "static/media/1862.378d70cd.png";